import { render, staticRenderFns } from "./pay-channels.vue?vue&type=template&id=6fda88d1&scoped=true&"
import script from "./pay-channels.vue?vue&type=script&lang=js&"
export * from "./pay-channels.vue?vue&type=script&lang=js&"
import style0 from "./pay-channels.vue?vue&type=style&index=0&id=6fda88d1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fda88d1",
  null
  
)

export default component.exports